import Vue from 'vue'   
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
  {
    path:'/',
    component: ()=>import ('@/views/userlogin/userLogin.vue'),
    meta:{
        title:'登录'
      }
  },
  {
    path:'/login',
    component: ()=>import ('@/views/userlogin/userLogin.vue'),
    meta:{
        title:'登录'
      }
  },
  {
    path:'/pageList',
    component: () => import('@/views/homePage/index.vue'),
    meta:{
        title:'供应商大屏'
      }
 },
 {
  path:'/productIntroduce',
  component: () => import('@/views/menu/productIntroduce.vue'),
  meta:{
      title:'产品介绍'
    }
},
{
  path:'/designCenter',
  component: () => import('@/views/menu/designCenter.vue'),
  meta:{
      title:'设计中心'
    }
},
{
  path:'/designerDetails',
  component: () => import('@/views/menu/designerDetails.vue'),
  meta:{
      title:'设计师详情'
    }
},
{
  path:'/caseDetails',
  component: () => import('@/views/menu/caseDetails.vue'),
  meta:{
      title:'案例详情'
    }
},
{
  path:'/aboutJia',
  component: () => import('@/views/aboutJia/aboutJia.vue'),
  meta:{
      title:'关于极家'
    }
},
{
  path:'/constructionSite',
  component: () => import('@/views/constructionSite/constructionSite.vue'),
  meta:{
      title:'施工工地'
    }
},
{
  path:'/commodityList',
  component: () => import('@/views/commodity/commodityList.vue'),
  meta:{
      title:'商城首页'
    }
},
{
  path:'/ProductDetails',
  component: () => import('@/views/commodity/components/ProductDetails.vue'),
  meta:{
      title:'商城详情'
    }
},
{
  path:'/ShoppingCart',
  component: () => import('@/views/commodity/components/ShoppingCart.vue'),
  meta:{
      title:'购物车'
    }
},
{
  path:'/OrderFilling',
  component: () => import('@/views/commodity/components/OrderFilling.vue'),
  meta:{
      title:'订单填写'
    }
},
{
  path:'/PaySuccess',
  component: () => import('@/views/commodity/components/PaySuccess.vue'),
  meta:{
      title:'支付成功'
    }
},
{
  path:'/advertisementInfor',
  component: () => import('@/views/advertisement/advertisementInfor.vue'),
  meta:{
      title:'广告页'
    }
},
{
  path:'/OrderingInfor',
  component: () => import('@/views/commodity/components/OrderingInfor.vue'),
  meta:{
      title:'订单详情'
    }
},
{
  path:'/ProductDetailsreCommend',
  component: () => import('@/views/commodity/components/ProductDetailsreCommend.vue'),
  meta:{
      title:'商城详情'
    }
},
{
  path:'/EventDetails',
  component: () => import('@/views/components/EventDetails.vue'),
  meta:{
      title:'活动详情页'
    }
},
{
  path:'/lockScreen',
  component: () => import('@/views/advertisement/lockScreen.vue'),
  meta:{
      title:'广告页'
    }
},
{
  path:'/TiktokLive',
  component: () => import('@/views/components/TiktokLive.vue'),
  meta:{
      title:'抖音直播'
    }
},
]
// 
const router = new VueRouter({
    routes,
    // mode: "history",
})


router.beforeEach((to, from, next) => {
 
  // 路由跳转后，让页面回到顶部
  document.body.scrollTop = 0; 
  document.documentElement.scrollTop = 0; 
  window.pageYOffset = 0; 
 
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁!!
  next();
 
});

export default router